<template>
  <div class="topic" :style="getBgStyle" :class="{ 'pc-topic': !isMobile }">
    <div class="header">
      <div class="title">
        {{ topicDetail.name }}
      </div>
      <div class="subtitle">
        {{ topicDetail.share?.desc }}
      </div>
    </div>

    <van-row gutter="22">
      <van-col span="12" v-for="item in listItems.slice(0, 2)" :key="item.puid">
        <div
          @click="state.puid = item.puid"
          class="col-item"
          :class="{ on: item.puid === state.puid }"
        >
          <img :src="item.coverImg" />
        </div>
      </van-col>
    </van-row>

    <div class="list">
      <div
        @click="state.puid = item.puid"
        class="item"
        v-for="item in listItems.slice(2)"
        :key="item"
        :class="{ on: item.puid === state.puid }"
      >
        <img :src="item.coverImg || item.goods_cover_image" />
      </div>
    </div>
    <van-button
      :color="topicDetail.btn_color"
      block
      round
      @click="handleConfirm"
      class="button"
      >立即测试</van-button
    >
    <div class="rich-text" v-html="topicDetail.content"></div>
  </div>
</template>

<script setup>
import { computed, reactive } from "vue";

import { Toast } from "vant";
import { useCreateOrder } from "./useCreateOrder";
import { useAgent } from "@/hooks/useAgent";
const { isMobile } = useAgent();

const props = defineProps({
  topicDetail: {
    type: Object,
    default: () => ({}),
  },
  goodsList: {
    type: Array,
    default: () => [],
  },
});

const listItems = computed(() => {
  const { cover_image, cover_image2, cover_image3 } = props.topicDetail;
  const coverImgList = [cover_image, cover_image2, cover_image3];
  props.goodsList.map((item, itemIndex) => {
    coverImgList.map((img, imgIndex) => {
      if (itemIndex === imgIndex) item.coverImg = img;
    });
  });
  return props.goodsList;
});

const getBgStyle = computed(() => {
  const { bg_color, bg_image } = props.topicDetail;
  return {
    backgroundColor: bg_color,
    backgroundImage: `url(${bg_image})`,
  };
});

const state = reactive({
  puid: "",
});
const [confirm] = useCreateOrder();
async function handleConfirm() {
  if (!state.puid) return Toast("请先选择测试题");
  const { guid, puid, goods_version } = props.goodsList.find(
    (item) => item.puid === state.puid
  );

  confirm({ guid, puid, goods_version });
}
</script>

<style lang="less" scoped>
.topic {
  min-height: 100vh;
  padding: 0 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;
  &.pc-topic {
    width: 600px;
    padding: 0 70px;
    margin: 0 auto;
    .on {
      border-width: 8px !important;
      &:before {
        border-width: 8px !important;
      }
    }
    .header {
      padding: 16px 0;
      .title {
        font-size: 28px;
      }
      .subtitle {
        font-size: 20px;
        line-height: 24px;
      }
    }

    .button {
      height: 70px;
      font-size: 24px;
    }
    .col-item {
      height: 240px;
      padding: 8px;
      cursor:pointer;
      img {
        width: 80%;
      }
    }
    .list {
      padding: 16px 0;
      .item {
        border-width: 8px;
        cursor:pointer;
      }
    }
  }
  .button {
    font-size: 20px;
    color: v-bind("topicDetail.goods_subtitle_color");
  }

  .header {
    padding: 46px 0 16px 0;
    color: #fff;
    text-align: center;

    .title {
      text-shadow: 2px 2px 4px v-bind("topicDetail.btn_color");
      font-size: 30px;
      padding-bottom: 8px;
      font-weight: 600;
    }

    .subtitle {
      font-size: 15px;
      text-shadow: 2px 2px 4px rgba(150, 150, 150, 1);
      width: 80%;
      margin: 0 auto;
      line-height: 24px;
    }
  }

  .col-item {
    width: 100%;
    height: 160px;
    border-radius: 16px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 8px;

    img {
      width: 100%;
    }

    &.on {
      padding: 0;
      border: 8px solid v-bind("topicDetail.btn_color");
    }
  }

  .list {
    padding: 20px 0;

    .item {
      margin-top: 16px;
      display: flex;
      justify-content: center;
      overflow: hidden;

      &:first-child {
        margin-top: 0;
      }

      img {
        width: 100%;
        height: 100%;
        border-radius: 16px;
      }

      &.on {
        position: relative;

        &::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          right: 0;
          border-radius: 16px;
          border: 8px solid v-bind("topicDetail.btn_color");
        }
      }
    }
  }

  .rich-text {
    padding: 15px 0;
    font-size: @font-size-base;
    color: #3f3f3f;
    line-height: 24px;

    :deep(img) {
      display: block;
      width: 100%;
    }
  }
}
</style>
